"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var context_1 = __importDefault(require("../../utils/theme/context"));
var form_1 = require("../form");
var ThemeSwitcher = function () {
    return (react_1["default"].createElement(context_1["default"].Consumer, null, function (value) { return (react_1["default"].createElement(form_1.Wrapper, { name: "shouldBeDark", type: "switch", label: value.shouldBeDark ? 'Dark theme' : 'Light theme' },
        react_1["default"].createElement(form_1.Switch, { name: "shouldBeDark", data: { shouldBeDark: value.shouldBeDark }, onChange: value.toggleDark }))); }));
};
exports["default"] = ThemeSwitcher;
